"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyTimelineEventType = void 0;
var JourneyTimelineEventType;
(function (JourneyTimelineEventType) {
    JourneyTimelineEventType["Audit"] = "Audit";
    JourneyTimelineEventType["JourneyJob"] = "JourneyJob";
    JourneyTimelineEventType["Notification"] = "Notification";
    JourneyTimelineEventType["Voice"] = "Voice";
})(JourneyTimelineEventType = exports.JourneyTimelineEventType || (exports.JourneyTimelineEventType = {}));
